define('common/utils/_',[
    'lodash/dist/lodash.compat'
], function (
    _
) {

    return _;

});

